// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ContentViewColumnIconSignature {
  Element: SVGSVGElement;
}

export const ContentViewColumnIcon: TOC<ContentViewColumnIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 21H4C2.896 21 2 20.103 2 19V5C2 3.897 2.896 3 4 3H6C7.104 3 8 3.897 8 5V19C8 20.103 7.104 21 6 21ZM13 21H11C9.896 21 9 20.103 9 19V5C9 3.897 9.896 3 11 3H13C14.104 3 15 3.897 15 5V19C15 20.103 14.104 21 13 21ZM18 21H20C21.104 21 22 20.103 22 19V5C22 3.897 21.104 3 20 3H18C16.896 3 16 3.897 16 5V19C16 20.103 16.896 21 18 21ZM18 19V5H20L19.997 19H18ZM11 19V5H13L12.997 19H11ZM4 19V5H6L5.997 19H4Z"/>
</svg>
</template>;